import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class IconPosition extends BaseOption {
  static userInterfaceComponent = {
    label: "Icon Position",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 15,
      maxItemsPerRow: -1,
      options: [
        {
          icon: "position-left",
          tooltip: "Left",
          value: "beforeText",
        },
        {
          icon: "position-right",
          tooltip: "Right",
          value: "afterText",
        },
        {
          icon: "position-top",
          tooltip: "Top",
          value: "aboveText",
        },
        {
          icon: "position-bottom",
          tooltip: "Bottom",
          value: "belowText",
        },
        {
          icon: "mdi:eye-off-outline",
          tooltip: "Icon only",
          value: "noText",
        },
      ],
    },
  };

  static defaultValue = "beforeText";
}
